const COVERAGE_STATEMENT_VALUE_MAX_LENGTH = 350;

export default COVERAGE_STATEMENT_VALUE_MAX_LENGTH;
